import React from "react";
import { Link } from "react-router-dom";

type InstagramLinkProps = Omit<React.ComponentProps<typeof Link>, "to"> & {
  children: React.ReactNode;
  link: string;
};

const InstagramLink: React.FC<InstagramLinkProps> = ({ children, link, tabIndex }) => (
  <a className="InstagramLink" href={link} target="_blank" rel="noopener noreferrer" tabIndex={tabIndex || 0}>
    {children}
  </a>
);

export default InstagramLink;
